import type { IGenericBaseModel } from "models/shared/GenericBaseModel";
import { OrganizationSimpleModel } from "models/company/entities/OrganizationSimpleModel";

export interface ILockerSimpleModel extends IGenericBaseModel {
    uuid: string;
    name: string
    containersCount: number
    hoursToReverse: number
    organization: OrganizationSimpleModel
}


export class LockerSimpleModel implements ILockerSimpleModel {
    uuid: string;
    name: string
    containersCount: number
    hoursToReverse: number
    organization: OrganizationSimpleModel

    constructor(data: ILockerSimpleModel){
        this.uuid= data.uuid;
        this.name = data.name;
        this.containersCount = data.containersCount;
        this.hoursToReverse = data.hoursToReverse;
        this.organization = new OrganizationSimpleModel(data.organization); 
    }
}